import { APP_LOGO } from "@/const";

export default function Footer() {
  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12 mb-8">
          {/* Logo and Description */}
          <div>
            <img 
              src={APP_LOGO} 
              alt="Suite Global Estate" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-muted-foreground leading-relaxed mb-6">
              Your trusted partner for luxury real estate investment in Dubai. We manage your asset and secure your peace of mind.
            </p>
            <p className="text-sm text-muted-foreground">
              Fill out our contact form to receive detailed information about Motor City investment opportunities and schedule a consultation with our specialists.
            </p>
          </div>

          {/* Investment Highlights */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-card-foreground">Investment Highlights</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li>• 10%+ Target Rental Income</li>
              <li>• From $250,000</li>
              <li>• 20% Down Payment</li>
              <li>• 3-Year Payment Plan</li>
              <li>• Golden Visa Eligible</li>
              <li>• 0% Property Tax</li>
              <li>• Delivery: December 2027</li>
              <li>• 40+ Resort-Style Amenities</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <p className="text-sm text-muted-foreground">
                © {new Date().getFullYear()} Suite Global Estate. All rights reserved.
              </p>
              <span className="hidden sm:inline text-muted-foreground">•</span>
              <p className="text-sm text-muted-foreground">
                Marketing by{" "}
                <a 
                  href="https://focusads.ai/real-estate?utm_source=motor-city-dubai&utm_medium=footer&utm_campaign=suite-global-estate" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline font-semibold"
                >
                  focusads.ai
                </a>
              </p>
            </div>
            <p className="text-sm text-muted-foreground">
              Property ID: DXB-020 | Motor City, Dubai
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
